import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  format (event) {
    let value = event.target.value.replace(/\D/g, '')

    if (value.length === 0) {
      event.target.value = ''
      return
    }

    if (value.length <= 3) {
      value = `(${value}`
    } else if (value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`
    } else if (value.length <= 10) {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`
    } else {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`
    }

    event.target.value = value
  }
}
